import React from "react";
import { IntlProvider } from "react-intl";
import hubAPI from "../services/hubAPI";
import Loader from "../helpers/loader-full";
import moment from "moment";
import translate_es from "../translations/es.json";
import translate_en from "../translations/en.json";
import translate_pt from "../translations/pt.json";

export class CustomIntlProviderBase extends React.Component {
  state = {
    loaded: true,
    error: false,
    translations: {
      es: translate_es,
      en: translate_en,
      pt: translate_pt,
    },
  };

  checkTranslations = () => {
    const { translations } = this.state;
    const now = moment();
    const translationDate = moment(
      localStorage.getItem("translationDate") || "19900101",
      "YYYYMMDD",
    );
    const diff = now.diff(translationDate, "days");

    if (diff >= 1) this.getTranslations();
    else {
      const storageTranslations = localStorage.getItem("translations");
      if (!storageTranslations) this.getTranslations();
      else {
        const objTranslations = JSON.parse(storageTranslations);
        this.setState({
          translations: { ...translations, ...objTranslations },
          loaded: true,
        });
      }
    }
  };

  getTranslations = () => {
    console.log("[INTL]: gettings translations");
    this.setState({ loaded: false, error: false });

    hubAPI
      .get("/api/v1/Translate")
      .then((response) => {
        this.processTranslations(response.data);
        console.log("[INTL]: gettings translations done");
      })
      .catch((error) => {
        this.setState({ loaded: true, error: true });
        console.error("[INTL]: gettings translations errow", error);
        return;
      });
  };

  processTranslations = (data) => {
    const { translations } = this.state;

    let baseTranslations = Object.assign({}, translations);

    //Complement
    data.data.forEach((culture) => {
      //specific culture
      if ((culture.culture || "xx").includes("-")) {
        const languagePart = culture.culture.split("-")[0];

        //add missing values to specific-culture from neutral culture
        const neutralCulture = data.data.find((f) => f.culture == languagePart);
        if (!!neutralCulture)
          culture.values = { ...neutralCulture.values, ...culture.values };

        //add missing values to specific culture from local resources
        if (!!translations[languagePart])
          culture.values = { ...translations[languagePart], ...culture.values };
      } else {
        if (!!translations[culture.culture])
          culture.values = {
            ...translations[culture.culture],
            ...culture.values,
          };
      }

      if (!baseTranslations[culture.culture])
        baseTranslations[culture.culture] = culture.values;
      else
        baseTranslations[culture.culture] = {
          ...baseTranslations,
          ...culture.values,
        };
    });

    this.setState(
      { translations: baseTranslations, loaded: true, error: false },
      () => {
        try {
          localStorage.setItem(
            "translations",
            JSON.stringify(this.state.translations),
          );
          localStorage.setItem("translationDate", moment().format("YYYYMMDD"));
        } catch (error) {
          console.error(error);
        }
      },
    );
  };

  componentDidMount() {
    console.log("[INTL]: Translation provider started");
    window.tt = {
      es: translate_es,
      en: translate_en,
      pt: translate_pt,
    };
    this.checkTranslations();
  }
}

class CustomIntlProvider extends CustomIntlProviderBase {
  render() {
    const { translations, loaded } = this.state;
    const { children, locale } = this.props;
    let language = !!translations[locale] ? locale : locale.substr(0, 2);

    if (!loaded)
      return <Loader full={true} text="Getting language resources..." />;

    return (
      <IntlProvider locale={locale} messages={translations[language]}>
        {children}
      </IntlProvider>
    );
  }
}

export default CustomIntlProvider;
